/** @format */

import {forwardRef} from 'react';

import {styled} from '@mui/material/styles';

import BaseTextField, {BaseTextFieldProps} from './BaseTextField';

const PREFIX = 'MediumTextField';

const classes = {
  root: `${PREFIX}-root`,
};

const StyledBaseTextField = styled(BaseTextField)(({theme}) => ({
  backgroundColor: theme.palette.secondary.main,
  borderRadius: 8,
  width: '100%',
  '&:hover fieldset': {
    borderColor: theme.palette.action.hover,
  },
  '& fieldset': {
    borderColor: theme.palette.figma_gray_middle?.main,
  },
  '& .MuiInputBase-input': {
    color: theme.palette.text.secondary,
    height: 'unset',
  },
  '& .MuiInputBase-root': {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '20px',
  },
  '& input.MuiOutlinedInput-input': {
    padding: '14px 16px',
  },
}));

const MediumTextField = forwardRef((props: BaseTextFieldProps, ref) => {
  return <StyledBaseTextField className={classes.root} inputRef={ref} {...props} />;
});

MediumTextField.displayName = 'MediumTextField';

export default MediumTextField;
